import { ArrowRight } from "lucide-react";
import { BOOKING_URL, HERO_PHOTO } from "@/data/content";
import { SP_WIDGET_ATTRS } from "./BookingButton";

export default function Hero() {
  return (
    <section className="relative" data-testid="hero-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-16 lg:pt-24 pb-20 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-7 soft-up">
          <div className="eyebrow mb-6" data-testid="hero-eyebrow">Sano Acupuncture · Bronx, New York</div>
          <h1 className="font-serif-display text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
            Feel <em className="italic" style={{ color: "var(--sano-olive)" }}>better</em>
            <br />in your body
            <br />again.
          </h1>

          <p className="mt-8 max-w-xl text-lg leading-relaxed" style={{ color: "var(--sano-ink-2)" }}>
            Acupuncture and holistic wellness care designed to reduce stress,
            relieve pain, regulate your nervous system, and support your overall
            well-being. Ten years of practice. Quiet, lasting medicine.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noreferrer"
              {...SP_WIDGET_ATTRS}
              className="group inline-flex items-center gap-3 px-7 py-3.5 rounded-full text-sm font-medium text-[#F9F6F0] transition-all hover:scale-[1.02]"
              style={{ background: "var(--sano-olive)" }}
              data-testid="hero-book-btn"
            >
              Book your appointment
              <ArrowRight size={16} strokeWidth={1.5} className="transition-transform group-hover:translate-x-1" />
            </a>
            <a
              href="tel:9292726066"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full text-sm font-medium border transition-all hover:bg-[#EAEAE0]"
              style={{ borderColor: "var(--sano-ink)", color: "var(--sano-ink)" }}
              data-testid="hero-call-btn"
            >
              Free phone consultation
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs uppercase tracking-widest" style={{ color: "var(--sano-ink-2)" }}>
            <span>★ Google reviewed</span>
            <span>· 10+ years of practice</span>
            <span>· Bronx, NY</span>
            <span>· Insurance accepted</span>
          </div>

          <div className="mt-14 grid grid-cols-3 gap-6 max-w-lg">
            {[
              { k: "10+", v: "years of practice" },
              { k: "6+", v: "insurance plans" },
              { k: "1", v: "very calm room" },
            ].map((s) => (
              <div key={s.v}>
                <div className="font-serif-display text-3xl" style={{ color: "var(--sano-olive)" }}>{s.k}</div>
                <div className="text-xs uppercase tracking-widest mt-1" style={{ color: "var(--sano-ink-2)" }}>
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div
            className="relative overflow-hidden rounded-sm flex items-center justify-center"
            style={{ background: "var(--sano-bg-2)", height: 520 }}
          >
            <img
              src={HERO_PHOTO}
              alt="Sano Acupuncture logo"
              className="max-w-[78%] max-h-[78%] object-contain"
              style={{ imageRendering: "auto" }}
              loading="eager"
              data-testid="hero-image"
            />
          </div>
          <div
            className="absolute -bottom-8 -left-6 px-6 py-5 max-w-[260px] border"
            style={{ background: "var(--sano-bg)", borderColor: "var(--sano-border)" }}
          >
            <div className="eyebrow mb-2">Signature</div>
            <div className="font-serif-display text-2xl leading-tight">Nervous System Reset</div>
            <div className="text-xs mt-2" style={{ color: "var(--sano-ink-2)" }}>
              75 min · acupuncture + breath
            </div>
          </div>
        </div>
      </div>

      {/* Editorial ribbon */}
      <div
        className="border-y overflow-hidden py-5"
        style={{ background: "var(--sano-bg-3)", borderColor: "var(--sano-border)" }}
      >
        <div className="ribbon-track flex gap-32 whitespace-nowrap font-serif-display text-3xl">
          {[...Array(2)].map((_, i) => (
            <div key={i} className="flex gap-32 shrink-0">
              <span>Slow medicine</span>
              <span>·</span>
              <span>Nervous system reset</span>
              <span>·</span>
              <span>Five elements</span>
              <span>·</span>
              <span>Community wellness</span>
              <span>·</span>
              <span>Acupuncture in New York</span>
              <span>·</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
